import { http } from "../../../../utils/httpConf";
import { util } from "../../../../utils/zgyAxiosconf";
import { consolePanel } from "./msConfig";




const consolePanelReq = {
  /**
   * 获取顶部导航栏
   * @param params
   * @returns {httpPromise<any>}
   */
  getNavTopMenu: (params = {}) => {
    let url = consolePanel.getNavTopMenu;
    return http.get(url, {params: params});
  },

  /**
   * 获取region
   * @param params
   * @returns {httpPromise<any>}
   */
  getRegion: (params = {}) => {
    let url = consolePanel.getRegion;
    return util.get(url, {params: params});
  },

  /**
   * 获取可用余额
   * @param params
   * @returns {httpPromise<any>}
   */
  getAccountRemainder: (params = {}) => {
    let url = consolePanel.getAccountRemainder;
    return http.get(url, {params: params});
  },

  /**
   * 获取消息条数
   * @param params
   * @returns {httpPromise<any>}
   */
  getMessageCount: (params = {}) => {
    let url = consolePanel.getMessageCount;
    return http.get(url, {params: params});
  },

  /**
   * 获取未读消息
   * @param params
   * @returns {httpPromise<any>}
   */
  getUnreadMessage: ( params = {}) => {
    let url = consolePanel.getUnreadMessage;
    return http.get(url, {params: params});
  },


  /**
   * 获取待处理工单
   * @param params
   * @returns {httpPromise<any>}
   */
  getPendingOrder: (params = {}) => {
    let url = consolePanel.getPendingOrder;
    return http.get(url, {params: params});
  },

  /**
   * 登出
   * @data data
   * @returns {httpPromise<any>}
   */
  logout: () => {
    let url = consolePanel.logout;
    return http.delete(url);
  },
  /**
   * 子用户登出
   * @data data
   * @returns {httpPromise<any>}
   */
  childLogout: () => {
    let url = consolePanel.childLogout;
    return http.delete(url);
  },
  
  /**
   * 获取默认导航
   * @data data
   * @returns {httpPromise<any>}
   */
  getDefaultMenu: () => {
    let url = consolePanel.getDefaultMenu;
    return http.get(url);
  },

  /**
   * 添加自定义导航
   * @data data
   * @returns {httpPromise<any>}
   */
  addCustomMenu: data => {
    let url = consolePanel.addCustomMenu;
    return http.post(url, data);
  }
};

export default consolePanelReq;

